import { maxBy } from 'lodash';
import { WidgetViewMode } from 'utilitys/reporting/widgetViewModeUtils';

import { useUpdateIfReady } from 'components/Dashboards/Reporting/widgetInReport/hooks/RefreshWidgetPayload/useUpdateIfReady';
import { maxValueScale } from 'components/widgets/ProjectSummary/components/CardsSection/CardsSection.utils';
import { UseSpiTrendProvider } from 'components/widgets/SpiTrend/SpiTrend.provider';

interface Props {
    api: UseSpiTrendProvider['api'];
    setIsPayloadReady?: (newValue: boolean) => void;
    widgetViewMode?: WidgetViewMode;
}

export const useSpiTrendLogic = ({ api, setIsPayloadReady, widgetViewMode }: Props) => {
    useUpdateIfReady({ isPayloadReadyCallback: isPayloadReady, widgetViewMode: widgetViewMode });

    function isPayloadReady() {
        const currentPayload = api.getSpiTrend.payload;
        if (!currentPayload) return;
        if (
            currentPayload.compareVersionId === undefined ||
            currentPayload.latestVersionId === undefined ||
            currentPayload.contractId === undefined ||
            currentPayload.contractId === null
        )
            return;
        setIsPayloadReady && setIsPayloadReady(true);
    }

    const maxValuePoint = maxBy(api.getSpiTrend.instance.data?.[0]?.graphPoints, 'score');
    const maxValue = maxValuePoint ? maxValuePoint?.score * maxValueScale : undefined;

    return {
        logic: {
            maxValue,
        },
    };
};
